import { useState, useEffect, Fragment } from "react";
import { Button } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
// import { Snackbar } from '@material-ui/core';
import {Snackbar} from "@mui/material";
import { SHOW_SNACKBAR, HIDE_SNACKBAR } from "@util/constant";
import { subscribe, unsubscribe } from "@util/event";

const GlobalSnackbar = () => {
  const [open, set_open]  = useState(false)
  const [message, set_message] = useState('')
  const autoHideDuration = 3000
  
  const showSnackbar = (e) => {
    const msg = e?.detail || (typeof e === 'string' ? e : '')
    
    if (msg) {
      set_message(msg)
      set_open(true)
    }
  }

  const hideSnackbar = () =>{
    set_open(false)
  }

  const closeAction = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={hideSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  )
 
  useEffect(() => {
    if(open) {
      setTimeout(() => {
        set_open(false)
      }, autoHideDuration)
    }
  }, [open])

  useEffect(() => {
    subscribe(SHOW_SNACKBAR, showSnackbar)
    subscribe(HIDE_SNACKBAR, hideSnackbar)

    return () => {
      unsubscribe(SHOW_SNACKBAR, showSnackbar)
      unsubscribe(HIDE_SNACKBAR, hideSnackbar)
    }
  },[]) 



  return(
    <Snackbar
      open={open}
      // message={messageRef.current}
      message={message}
      action={closeAction}
    />
  )
}

export default GlobalSnackbar
